<template>
	<div class="g-inline-promotion g-layout__item">
		<div v-html="result.content" class="g-inline-promotion__inner"></div>
	</div>
</template>

<script>
	export default {
		props: {
			result: {
				default() {
					return {};
				}
			}
		}
	}
</script>